import { Box, Typography, Paper, Grid, Avatar, Stack, Tooltip } from '@mui/material';
import { AccessTimeIcon, AttachMoneyIcon, InfoIcon, InfoOutlineIcon } from '../../../Components/Icons/Icons';
import { AppColors } from '../../../Utils/helper/AppColors';

import clcok from '../../../Assets/Icons/Dashboard/clock-nine.svg';
import dollar from '../../../Assets/Icons/Dashboard/usd-circle.svg';
import layer from '../../../Assets/Icons/Dashboard/layer-group.svg';
import user from '../../../Assets/Icons/Dashboard/users.svg';
import info from '../../../Assets/Icons/Dashboard/infoIcon.svg';
import { Percent } from 'antd/es/progress/style';
import CustomInfoTooltip from '../../../Components/CustomInfoTooltip';

const DetailedCard = ({ heading, src, data }) => {
	return (
		<Grid
			item
			xs={12} // Full width on extra small screens
			sm={6} // Two cards per row on small screens
			md={3} // Four cards per row on medium and larger screens
		>
			<Paper
				elevation={1}
				sx={{
					height: '134px',
					px: 1.5,
					py: 2,
					pb: '30px',
					borderRadius: '10px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					border: `1px solid ${AppColors.BORDER_SECONDARY}`,
					boxShadow: '0px 4px 14px #68686840',
				}}
			>
				<Stack direction="row" alignItems="flex-start" gap={1}>
					<Avatar alt={src} src={src} sx={{ width: 24, height: 24 }} />

					<Typography
						sx={{ flexWrap: 'none' }}
						fontSize={16}
						fontWeight={600}
						lineHeight={'150%'}
						fontFamily={'Poppins'}
						color={AppColors.HEADING_TITLE}
					>
						{heading}
					</Typography>
				</Stack>

				<Box>
					{data.map((item, idx) => (
						<Stack
							direction={'row'}
							alignItems="center"
							gap={1}
							key={idx}
							sx={{ display: 'flex', paddingLeft: 4, mt: idx > 0 ? 1 : 0 }}
						>
							<Typography fontSize={14} fontWeight={600} lineHeight={'150%'} fontFamily={'Poppins'} color={AppColors.LIGHT_GRAY}>
								{item.label}:
							</Typography>
							<Typography
								fontSize={14}
								fontWeight={600}
								lineHeight={'150%'}
								fontFamily={'Poppins'}
								color={AppColors.HEADING_TITLE}
							>
								{item.value} {item.per && '%'}
							</Typography>
						</Stack>
					))}
				</Box>
			</Paper>
		</Grid>
	);
};

const SimpleCard = ({ label, value, src , tootltipTitle }) => {
	return (
		<Grid
			item
			xs={12} // Full width on extra small screens
			sm={6} // Two cards per row on small screens
			md={3} // Four cards per row on medium and larger screens
		>
			<Paper
				elevation={1}
				sx={{
					height: '134px',
					p: 2,
					borderRadius: '10px',
					padding: '16px',
					display: 'flex',
					flexDirection: 'column',
					gap: '10px',
					border: `1px solid ${AppColors.BORDER_SECONDARY}`,
					boxShadow: '0px 4px 14px #68686840',
				}}
			>
				<Stack direction="row" alignItems="flex-start" gap={1}>
					<Avatar alt={src} src={src} sx={{ width: 24, height: 24 }} />
					<Typography fontSize={16} fontWeight={600} lineHeight={'150%'} fontFamily={'Poppins'} color={AppColors.HEADING_TITLE}>
						{label}
					</Typography>
				</Stack>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Typography fontSize={24} fontWeight={600} lineHeight={'130%'} fontFamily={'Poppins'} color={AppColors.HEADING_TITLE}>
						{value}
					</Typography>
					<CustomInfoTooltip title={tootltipTitle} iconSize={20}  />
				</Box>
			</Paper>
		</Grid>
	);
};

// const infoCards = [
// 	{
// 		type: 'detailed',
// 		heading: 'Campaigns',
// 		src: layer,
// 		data: [
// 			{ label: 'Active', value: '50' },
// 			{ label: 'Total', value: '750' },
// 		],
// 	},
// 	{
// 		type: 'detailed',
// 		heading: 'Employee Participation',
// 		src: user,
// 		data: [
// 			{ label: 'Total', value: '1K+' },
// 			{ label: 'Participation', value: '95%' },
// 		],
// 	},
// 	{
// 		type: 'simple',
// 		src: clcok,
// 		label: 'Hours Saved',
// 		value: '3.18 Hrs',
// 	},
// 	{
// 		type: 'simple',
// 		src: dollar,
// 		label: 'Tentative Cost Saved',
// 		value: '$133.56',
// 	},
// ];

export default function InfoCards({ details }) {
	// console.log('info cards....');
	return (
		<Grid container spacing={2}>
			<DetailedCard
				heading={'Campaigns'}
				src={layer}
				data={[
					{ label: 'Active', value: details?.totalActiveCampaigns },
					{ label: 'Total', value: details?.totalCampaigns },
				]}
			/>

			<DetailedCard
				heading={'Employee Participation'}
				src={user}
				data={[
					{ label: 'Total', value: details?.campaignTotalUsers <= 999 ? details?.campaignTotalUsers : '1K+' },
					{ label: 'Participation', value: details?.campaignParticipationRate, per: true },
				]}
			/>

			<SimpleCard
				label={'Total Conversation Hours'}
				value={details?.hoursSaved + ' Hrs'}
				src={clcok}
				tootltipTitle="Estimated total hours saved by automating tasks using the AI Agent instead of manual effort."
			/>

			<SimpleCard label={'Saving Impact'} value={`$${details?.costSaved}`} src={dollar} tootltipTitle={'Estimated monetary savings based on the hours automated by the AI Agent, calculated at a standard rate of $40/hour.'} />
		</Grid>
	);
}
